<template>
  <div
    :class="borderClass"
    class="col-sm bg-secondary-3 mx-1 px-4 py-3 rounded"
  >
    <p :class="textClass" class="font-24 mb-0">{{ count }}</p>
    <div class="row">
      <div class="col-9">
        <p
          style="height: 100px;"
          class="font-16 mb-0 font-weight-normal color-black"
        >
          {{ content }}
        </p>
      </div>
      <div class="col-3">
        <span
          class="rounded-pill font-10 font-weight-normal text-light mt-1 mr-3 px-2 py-1 float-right"
          :class="badgeClass"
        >
          {{ percentageText }}
        </span>
      </div>
    </div>
    <p v-if="hasButton" :class="buttonContainerClass" class="mb-1">
      <action-button
        class="outline-success mr-3 btn-block"
        i="fa fa-print"
        :text="buttonText"
        @click="click()"
      />
    </p>
  </div>
</template>

<script>
import ActionButton from "ActionButton";

export default {
  name: "ResultRow",
  components: {
    ActionButton,
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    content: {
      type: String,
      default: "",
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "",
    },
    buttonContainerClass: {
      type: String,
      default: "text-danger",
    },
  },
  computed: {
    borderClass() {
      if (this.count > 0) return "border-left-red";
      return "border-left-green";
    },
    textClass() {
      if (this.count > 0) return "text-red";
      return "color-secondary-5";
    },
    badgeClass() {
      return this.count > 0 ? "bg-danger" : "bg-success";
    },
    percentageText() {
      return `${this.percentage}%`;
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_colors.scss";

@media (max-width: 425px) {
  .border-left-red {
    border-top: 2px solid map-get($colors, "red") !important;
    margin-top: 15px;
  }
  .border-left-green {
    border-top: 2px solid map-get($colors, "green") !important;
    margin-top: 15px;
  }
}
@media (min-width: 425px) {
  .border-left-red {
    border-left: 2px solid map-get($colors, "red") !important;
  }
  .border-left-green {
    border-left: 2px solid map-get($colors, "green") !important;
  }
}
</style>
